import type { ReportsTranslation } from './types';

/** Arabic (Modern Standard). Pending review by native speakers. */
export const reportsAr: ReportsTranslation = {
  nav: 'التقارير',
  title: 'التقارير',
  description:
    'كيف سارت المحادثات: الحجم والتحويل إلى الموظفين والحل والتقييمات، مع استخدام خطتك وفواتيرها. مجاميع فقط، دون محتوى الرسائل أبدًا.',
  export: 'تصدير CSV',
  exported: 'تم تنزيل تقرير CSV.',
  loading: 'جارٍ تحميل التقرير',
  tabs: {
    quality: 'جودة الخدمة',
    teams: 'نشاط الفرق',
    tickets: 'التذاكر',
    ai: 'استخدام الذكاء الاصطناعي',
    billing: 'الفوترة',
  },
  withheld: 'محجوب',
  smallSample: 'عينة صغيرة',
  fewer: 'محجوب: أقل من {{count}}',
  rateOf: '{{rate}} من {{count}}',
  previousValue: 'الفترة السابقة: {{count}}',
  responses: 'الردود: {{count}}',
  basedOn: 'المحادثات المقيسة: {{count}}',
  outOfFive: '{{value}} / 5',
  privacy:
    'لحماية الخصوصية، يُحجب أي رقم يستند إلى أقل من {{count}} محادثات أو ردود، ويُحجب معه الرقم الأصغر التالي حين يكشفه المجموع.',
  rangeNote: 'من {{from}} إلى {{to}}، والأيام بتوقيت {{zone}}.',
  partial: 'جزء من هذه الفترة يسبق بدء تسجيل التقارير، لذا لا يُحتسب.',
  partialSince: 'بدأ تسجيل التقارير في {{date}}؛ لا تُحتسب المحادثات السابقة لذلك.',
  filters: {
    range: 'التواريخ',
    ranges: {
      '7d': 'آخر 7 أيام',
      '30d': 'آخر 30 يومًا',
      '90d': 'آخر 90 يومًا',
      custom: 'فترة مخصّصة',
    },
    from: 'من',
    to: 'إلى',
    team: 'الفريق',
    allTeams: 'كل الفرق',
    channel: 'القناة',
    allChannels: 'كل القنوات',
  },
  tiles: {
    conversations: 'المحادثات',
    handoffs: 'التحويل إلى الموظفين',
    resolved: 'المحلولة',
    feedback: 'تقييم العملاء',
    aiResolved: 'حلّها الذكاء الاصطناعي',
    firstResponse: 'وسيط أول رد',
    resolution: 'وسيط وقت الحل',
  },
  chart: {
    title: 'المحادثات يوميًا',
    summary:
      'مخطط خطي للمحادثات يوميًا من {{from}} إلى {{to}}، مع الفترة السابقة. يسرد الجدول أدناه كل الأيام.',
    current: 'هذه الفترة',
    previous: 'الفترة السابقة ({{from}} – {{to}})',
    currentShort: 'هذه الفترة',
    previousShort: 'الفترة السابقة',
    caption: 'تُحجب الأيام التي فيها أقل من {{count}} محادثات وتظهر فجوات.',
    table: 'عرض الأرقام في جدول',
    date: 'اليوم',
  },
  reasons: {
    title: 'لماذا حُوّلت المحادثات إلى الموظفين',
    empty: 'لا تحويلات في هذه الفترة.',
    reason: 'السبب',
    count: 'المحادثات',
    names: {
      customer_request: 'طلب العميل التحدث إلى موظف',
      ai_unavailable: 'نموذج الذكاء الاصطناعي غير متاح',
      ai_blocked: 'حُجب رد الذكاء الاصطناعي',
      ai_limit: 'بلغ الذكاء الاصطناعي الحد أو الميزانية',
      ai_stopped: 'أُوقفت ردود الذكاء الاصطناعي',
      no_agent: 'لم يُنشر وكيل ذكاء اصطناعي',
      assist_mode: 'الذكاء الاصطناعي يقترح الردود فقط',
      channel_ai_off: 'الذكاء الاصطناعي لا يرد على هذه القناة',
      staff_takeover: 'تولّى موظف المحادثة',
      staff_reply: 'ردّ موظف',
      staff_assign: 'أُسندت إلى موظف',
      staff_release: 'أُعيدت إلى قائمة الانتظار',
      authority_assignment: 'أُسندت في Chatwoot',
      authority_handoff: 'حُوّلت في Chatwoot',
      human_reply: 'ردّ موظف في Chatwoot',
      return_to_ai: 'أُعيدت إلى الذكاء الاصطناعي',
      unknown: 'غير مسجّل',
    },
  },
  quality: {
    title: 'محادثات لم تسر على ما يرام',
    description:
      'عملاء كتبوا ولم يتلقوا ردًا خلال ساعة، ورسائل تُركت عبر نموذج التواصل حين لم يكن أحد متاحًا للرد، ومحادثات مغلقة فُتحت من جديد.',
    missed: 'محادثات فائتة',
    missedNote: '{{rate}} من {{count}} محادثة كتب فيها العميل',
    offlineMessages: 'رسائل نموذج التواصل',
    offlineMessagesNote: 'تُركت حين لم يكن أحد متاحًا للرد',
    reopened: 'معدل إعادة الفتح',
    reopenedNote: 'من {{count}} محادثة مغلقة، فُتحت من جديد',
  },
  tickets: {
    title: 'التذاكر',
    created: 'أُنشئت',
    createdNote: 'فُتحت في هذه الفترة',
    closed: 'أُغلقت',
    closedNote: 'فُتحت في هذه الفترة وأُغلقت بعدها',
    openNow: 'مفتوحة الآن',
    openNowNote: 'مفتوحة أو بانتظار العميل، أيًّا كان وقت فتحها',
    closeMedian: 'الوسيط لوقت الإغلاق',
    byPriority: 'حسب الأولوية',
    bySource: 'حسب المصدر',
    priority: 'الأولوية',
    source: 'المصدر',
    count: 'التذاكر',
    priorities: {
      urgent: 'عاجلة',
      high: 'عالية',
      medium: 'متوسطة',
      low: 'منخفضة',
      none: 'بلا أولوية',
    },
    sources: {
      offline_form: 'نموذج التواصل',
      staff: 'الفريق',
      automation: 'الأتمتة',
      email: 'البريد الإلكتروني',
    },
    emptyList: 'لا تذاكر في هذه الفترة.',
    empty: {
      title: 'لا تذاكر في هذه الفترة',
      description:
        'تأتي التذاكر من نموذج التواصل والبريد الإلكتروني وفريقك والأتمتة. جرّب فترة مختلفة.',
    },
  },
  commerce: {
    title: 'الطلبات والمبالغ المستردة',
    description: 'الطلبات المقدَّمة في المحادثات والمبالغ المستردة، لكل عملة.',
    empty: 'لا طلبات ولا مبالغ مستردة في هذه الفترة.',
    currency: 'العملة',
    orders: 'الطلبات',
    revenue: 'المدفوع',
    refunds: 'عمليات الاسترداد',
    refunded: 'المسترد',
  },
  teams: {
    title: 'أداء قوائم الانتظار',
    description: 'الفرق بحسب المحادثات في قائمة انتظارها.',
    team: 'الفريق',
    conversations: 'المحادثات',
    firstResponse: 'وسيط أول رد',
    handoffRate: 'نسبة التحويل',
    feedback: 'تقييم العملاء',
    unnamed: 'فريق بلا اسم',
    none: 'دون فريق',
  },
  channels: {
    title: 'القنوات',
    channel: 'القناة',
    unknown: 'قناة غير معروفة',
  },
  replyTargets: {
    title: 'أهداف وقت الرد',
    description:
      'كم مرة ردّ موظف ضمن هدف وقت الرد للعلامة التجارية. يُحتسب الهدف عند انتهاء مؤقّته؛ والمؤقتات التي انتهت دون رد من موظف تُحتسب وحدها، لا كأهداف فائتة.',
    met: 'أهداف محققة',
    metNote: 'من {{count}} ردًا من موظفين',
    missed: 'أهداف فائتة',
    missedNote: 'ردود جاءت بعد الهدف',
    firstReply: 'الوسيط حتى أول رد',
    firstReplyNote: 'وقت العمل، دون وقت التأجيل. الردود المقيسة: {{count}}',
    stopped: 'انتهت دون رد',
    stoppedNote: 'استعاد الذكاء الاصطناعي المحادثة، أو حُلّت',
    byPriority: 'حسب الأولوية',
    byDay: 'حسب اليوم',
    replies: 'الردود',
    metShare: 'محقق',
    none: 'لم ينتهِ أي مؤقّت لوقت الرد في هذه الفترة.',
    recordingSince: 'تُسجَّل أهداف وقت الرد منذ {{date}}.',
    notRecorded: 'لم يُسجَّل شيء بعد. تظهر النتائج عندما يردّ موظف في محادثة لها هدف لوقت الرد.',
  },
  offers: {
    title: 'محادثات تُعرض على شخص واحد في كل مرة',
    description:
      'العروض المقدَّمة في هذه الفترة: المقبولة والمرفوضة والتي انتهت مهلتها، وأسباب الرفض، والتحويلات التي لم يأخذها أحد.',
    accepted: 'مقبولة',
    acceptedNote: 'من {{count}} عرضًا أُجيب عنه أو انتهت مهلته',
    declined: 'مرفوضة',
    expired: 'انتهت مهلتها',
    acceptTime: 'الوسيط حتى القبول',
    acceptTimeNote: 'العروض المقبولة: {{count}}',
    leftInQueue: 'بقيت في قائمة الانتظار',
    leftInQueueNote: 'تحويلات لم يقبلها أحد، من {{count}}',
    declineReasons: 'لماذا رفض الموظفون',
    reason: 'السبب',
    declinedCount: 'العروض المرفوضة',
    noDeclines: 'لم يُرفض أي عرض في هذه الفترة.',
    reasons: {
      at_capacity: 'محادثات كثيرة جدًا',
      not_my_area: 'ليس من اختصاصهم',
      going_offline: 'سيغادرون',
      other: 'سبب آخر',
    },
    byTeam: 'حسب الفريق',
    offered: 'العروض',
    none: 'لم تُعرض أي محادثات في هذه الفترة.',
    windowLimited: 'تُحفظ العروض 90 يومًا، لذلك لا تُحتسب الأيام الأقدم في هذه الفترة.',
  },
  aiDrafts: {
    title: 'مسودات الذكاء الاصطناعي للمراجعة',
    description:
      'المسودات التي كتبها الذكاء الاصطناعي ليراجعها موظف قبل الإرسال، وما فعله الموظفون بها.',
    sent: 'أُرسلت',
    sentNote: 'اعتُمدت كما هي أو بعد التعديل، من {{count}} مسودة قرر فيها الموظفون',
    edited: 'عُدّلت قبل الإرسال',
    rejected: 'رُفضت',
    rejectReasons: 'لماذا رُفضت المسودات',
    setAsideReasons: 'لماذا نُحّيت المسودات',
    reason: 'السبب',
    drafts: 'المسودات',
    noRejects: 'لم تُرفض أي مسودة في هذه الفترة.',
    noSetAside: 'لم تُنحَّ أي مسودة في هذه الفترة.',
    rejectNames: {
      inaccurate: 'كانت خاطئة',
      incomplete: 'كان ينقصها شيء',
      wrong_tone: 'كانت النبرة غير مناسبة',
      not_needed: 'لم يكن الرد ضروريًا',
      other: 'سبب آخر',
    },
    setAsideNames: {
      customer_wrote: 'كتب العميل مرة أخرى',
      owner_changed: 'انتقلت المحادثة إلى شخص آخر',
      answered: 'ردّ أحدهم يدويًا',
      replaced: 'حلّت محلها مسودة أحدث',
      resolved: 'حُلّت المحادثة',
    },
    byAgent: 'حسب وكيل الذكاء الاصطناعي',
    agent: 'وكيل الذكاء الاصطناعي',
    unknownAgent: 'لم يُسجَّل وكيل',
    none: 'لم تُكتب أي مسودات في هذه الفترة.',
    windowLimited: 'تُحفظ المسودات 90 يومًا، لذلك لا تُحتسب الأيام الأقدم في هذه الفترة.',
  },
  ai: {
    replies: 'ردود الذكاء الاصطناعي',
    tokens: 'رموز الذكاء الاصطناعي',
    tokensSplit: 'المدخلات {{input}} · المخرجات {{output}}',
    limitHandoffs: 'حُوّلت إلى الموظفين عند الحد',
    limitHandoffsNote: 'محادثات لم يستطع الذكاء الاصطناعي تولّيها لاستنفاد الخطة أو الميزانية.',
    cache: 'نسبة الإجابة من ذاكرة الإجابات المؤقتة',
    notMeasured: 'غير مقيس',
    notMeasuredNote:
      'تُحصي ذاكرة الإجابات المؤقتة لكل علامة تجارية ويوم؛ لم تكن هناك عمليات بحث هنا، أو هذا العرض بحسب الفريق أو القناة.',
    cacheNote:
      'نسبة الأسئلة الافتتاحية التي أُجيبت من الذاكرة المؤقتة (لكل علامة تجارية، بأيام UTC).',
  },
  empty: {
    title: 'لا نشاط في هذه الفترة',
    description: 'جرّب فترة أخرى أو أزل عوامل التصفية.',
    reset: 'إعادة ضبط التواريخ والتصفية',
  },
  billing: {
    loading: 'جارٍ تحميل الفوترة',
    plan: 'الخطة: {{plan}}، {{price}} شهريًا.',
    noPlan: 'لا توجد خطة مسندة إلى مساحة العمل هذه، لذا لا شيء محدود.',
    alerts: 'تنبيهات هذه الفترة',
    alert: 'بلغ {{limit}} نسبة {{threshold}}% في {{date}}.',
    usedOf: '{{used}} من {{max}}',
    usedUnlimited: 'استُخدم {{used}}، دون حد',
    meterLabel: 'المستخدم من {{limit}}',
    perPeriod: 'شهر الفوترة الحالي (UTC).',
    inUse: 'قيد الاستخدام الآن.',
    limits: {
      conversations: 'المحادثات',
      aiReplies: 'ردود الذكاء الاصطناعي',
      aiTokens: 'رموز الذكاء الاصطناعي',
      knowledgeStorageBytes: 'مساحة المعرفة',
      seats: 'المقاعد',
      webhookEndpoints: 'نقاط استقبال خطافات الويب',
    },
    states: {
      unlimited: 'دون حد',
      ok: 'ضمن الحد',
      warning: 'قريب من الحد',
      reached: 'بلغ الحد',
    },
    pastDue: {
      title: 'هناك فاتورة متأخرة',
      description: 'يُرجى سدادها، أو التواصل مع Hamnivo إن كان الدفع قد تم بالفعل.',
    },
    aiPaused: {
      plan_replies:
        'استُنفدت ردود الذكاء الاصطناعي في خطتك لهذا الشهر. تذهب المحادثات الجديدة إلى الموظفين حتى الشهر التالي أو خطة أكبر.',
      plan_tokens:
        'استُنفدت رموز الذكاء الاصطناعي في خطتك لهذا الشهر. تذهب المحادثات الجديدة إلى الموظفين حتى الشهر التالي أو خطة أكبر.',
      budget_tokens:
        'استُنفدت ميزانية الذكاء الاصطناعي لهذا الشهر. تذهب المحادثات الجديدة إلى الموظفين حتى ترفعها أو ينتهي الشهر.',
    },
    usage: {
      title: 'استخدام مساحة العمل',
      period: 'شهر الفوترة من {{from}} إلى {{to}}.',
    },
    budget: {
      title: 'ميزانية الذكاء الاصطناعي',
      description:
        'حدّد سقفًا شهريًا خاصًا بك لرموز الذكاء الاصطناعي، دون حد الخطة. عند بلوغه يتوقف الذكاء الاصطناعي مؤقتًا وتذهب المحادثات إلى الموظفين.',
      tokens: 'ميزانية رموز الذكاء الاصطناعي الشهرية',
      tokensHint: 'اتركه فارغًا لعدم وضع ميزانية غير حد الخطة.',
      alerts: 'نبّهني عند',
      threshold: '{{value}}%',
      save: 'حفظ الميزانية',
      saved: 'حُفظت الميزانية.',
      readOnly: 'لا يغيّر الميزانية إلا من يدير الفوترة.',
    },
    invoices: {
      title: 'الفواتير',
      empty: 'لا فواتير بعد.',
      number: 'الفاتورة',
      period: 'الشهر',
      total: 'الإجمالي',
      status: 'الحالة',
      due: 'تاريخ الاستحقاق',
      view: 'عرض',
      viewLabel: 'عرض الفاتورة {{number}}',
      statuses: {
        draft: 'مسودة',
        issued: 'صادرة',
        paid: 'مدفوعة',
        void: 'ملغاة',
      },
      overdue: 'متأخرة',
      paymentFailed: 'فشل الدفع',
      paidOn: 'دُفعت {{date}}',
    },
    invoice: {
      title: 'الفاتورة {{number}}',
      loading: 'جارٍ تحميل الفاتورة',
      period: 'خطة {{plan}}، من {{from}} إلى {{to}}.',
      item: 'البند',
      quantity: 'الكمية',
      amount: 'المبلغ',
      planLine: 'خطة {{plan}}',
      meteredLine: '{{limit}} بعد الـ {{included}} المشمولة',
      total: 'الإجمالي {{amount}}',
      taxNote: 'الضرائب غير مشمولة.',
    },
  },
};
